import { useRequest } from '~/lib/useRequest';
import { useQuery } from '@tanstack/react-query';
import { config } from '~/config';
import { hasKey } from '~/utils';
import { ConversionTableResource, GetConversionTableResponse } from '@ab/ams-school-api/types/private/v1';

export type GradeConversion = ConversionTableResource['attributes'] & {
  id: ConversionTableResource['id'];
  included?: ConversionTableResource['included'];
};

export function useGradeConversion(id: string, options?: { onSuccess?: (data: ConversionTableResource) => void }) {
  const request = useRequest();

  const { isLoading, isFetching, error, data, isError } = useQuery({
    queryKey: ['conversionTable', id],
    queryFn: async () => {
      const response = await request<GetConversionTableResponse>(
        `${config.apiHost}/private/v1/conversion_tables/${id}?include=grade_schema,education_level`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      const conversionTable = response.data;
      const attrs: GradeConversion = {
        id: conversionTable.id,
        ...conversionTable.attributes,
        included: conversionTable.included, // Pass through included data for grade schema
      };

      options?.onSuccess?.(conversionTable);

      return attrs;
    },
  });
  return {
    isLoadingConversionTable: isLoading,
    isFetchingConversionTable: isFetching,
    conversionTableError: error,
    conversionTable: data,
    isConversionTableError: isError,
  };
}

function isExpectedResponse(res: unknown): res is GetConversionTableResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
